"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hdkey = require("./vendor/hdkey-without-crypto");
exports.HDKey = hdkey;
//# sourceMappingURL=hdkey.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethereum-cryptography/pure/hdkey.js
// module id = eeA7
// module chunks = 0